export default __webpack_public_path__ + "static/media/gallery_09.a27bff99.jpg";